import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=0b9339e2"
import script from "./Authentication.vue?vue&type=script&lang=ts"
export * from "./Authentication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports